<template>
  <div class="app-wrapper">
    <!-- Sidebar cố định bên trái, scroll nội bộ -->
    <div class="sidebar-wrapper">
      <MenuParent v-if="getAppTypeUserLogin == appType.PARENT"/>
      <MenuSchool v-if="getAppTypeUserLogin == appType.SCHOOL"/>
      <MenuTeacher v-if="getAppTypeUserLogin == appType.TEACHER"/>
      <MenuSuperSchool v-if="getAppTypeUserLogin == appType.SUPPER_SCHOOL"/>
      <MenuAdminManagement v-if="getAppTypeUserLogin == appType.SUPPER_SYSTEM || getAppTypeUserLogin == appType.SYSTEM"/>
    </div>

    <!-- Cột phải: Navbar trên + nội dung dưới -->
    <div class="content-wrapper">
      <navbar/>
      <app-main />
    </div>
  </div>
</template>

<script>
import AppMain from "./components/AppMain.vue";
import Navbar from "./components/Navbar.vue";
import MenuParent from "@/layout/components/MenuParent.vue";
import MenuSchool from "@/layout/components/MenuSchool.vue";
import MenuTeacher from "@/layout/components/MenuTeacher.vue";
import MenuSuperSchool from "@/layout/components/MenuSuperSchool.vue";
import MenuAdminManagement from "@/layout/components/MenuAdminManagement";
import {appType} from "@/constant/listCommon";

export default {
  name: "Layout",
  components: {
    MenuSuperSchool,
    MenuTeacher,
    MenuSchool,
    MenuParent,
    AppMain,
    Navbar,
    MenuAdminManagement,
    // Menu,
  },
  data() {
    return {
      appType,
    };
  },
  computed: {
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Toàn bộ app: hàng ngang — sidebar trái + content phải */
.app-wrapper {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
  width: 100%;
}

/* Sidebar: cố định chiều cao, scroll dọc nếu nhiều mục */
.sidebar-wrapper {
  flex-shrink: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  /* Scrollbar mỏng */
  scrollbar-width: thin;
  scrollbar-color: #c5d3e8 transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c5d3e8;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #a0b4d0;
  }
}

/* Cột phải: navbar + nội dung, xếp dọc, chiếm phần còn lại */
.content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
</style>
